/*******************************
 * Example usage:
 *
 * window.addEventListener('resizeEnd', () => {
 * 		// do something, window hasn't changed size in 500ms
 * });
 ******************************/

import { debounce } from '@/js/util/helpers.js'

window.addEventListener(
  'resize',
  debounce(500, () => {
    window.dispatchEvent(new CustomEvent('resizeEnd'))
  }),
)
